import { YStack } from 'tamagui'
import { useStateCode } from '@/src/common/hooks/useMortgageModuleGeoIPBehavior'
import * as Mortgage from '@/src/experiences/mortgage'
import { MesaSectionSkeleton } from './MesaSectionSkeleton'
import { Section } from '../Section'
import { SegmentDomainProvider } from '@/src/services/segment/SegmentDomainProvider'

export function MesaSection() {
  const stateCodeResult = useStateCode()
  const stateConfig = Mortgage.Hooks.useStateConfig(stateCodeResult)

  if (
    stateConfig === 'loading' ||
    stateCodeResult === 'uninitialized' ||
    stateCodeResult === 'loading'
  ) {
    return <MesaSectionSkeleton />
  }

  if (!stateConfig.enableHomeSection) {
    return null
  }

  return (
    <SegmentDomainProvider domain="MesaMortgage">
      <Section
        title="Mesa Mortgage"
        subtitle="Earn 1:1 Mesa Points on your total loan amount when you buy or refinance with Mesa Mortgage. Plus, get expert guidance and competitive rates you can trust every step of the way."
      >
        <YStack gap="$4">
          <Mortgage.Components.StateCallPromoCard />
          <Mortgage.Components.BenefitsCard />
          <Mortgage.Components.PointsCalculatorCard />
        </YStack>
      </Section>
    </SegmentDomainProvider>
  )
}
